<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{'account.change_plan' | translate}}</h4>
    <button type="button" class="close" (click)="activeModal.close()">&times;</button>
</div>
<div class="modal-body pt-0">
    <div class="row" >
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12" *ngFor="let p of _plans">
            <div class="card-deck">
                <div [class]="(p.id!=_selectedPlan)?'card card-body-enabled mt-2':'card card-body-disabled mt-2'">
                    <div class="card-body">
                        <div class="text-responsive text-center mb-2">
                            <h3>{{(p.name.length > 12? (p.name | slice:0:9) + '...' : p.name) | translate}}</h3>
                        </div>
                        <div class="text-right">
                            <span>USD <h2 [class]="(p.id!=_selectedPlan)?'red-text':''">${{p.annualPrice | number}}</h2><i> {{'account.yearly' | translate}}</i></span><br>
                            USD <span [class]="(p.id!=_selectedPlan)?'red-text':''">${{p.monthlyPrice | number}}</span><span class="small"><i> {{'account.monthly' | translate}}</i></span>
                        </div>
                        <hr>
                        <ul>
                            <li><strong>{{'roles.agents_supervisors' | translate}}: </strong>{{p.agentsSupervisors}}</li>
                            <li><strong>{{'plan.Users' | translate}}: </strong>{{p.users}}</li>
                            <li *ngIf="p.includesVideo"><strong>{{'plan.video_feature' | translate}}</strong></li>
                            <li *ngIf="p.agentDispatch"><strong>{{'plan.agent_dispatch' | translate}}</strong></li>
                            <li *ngIf="p.geoAssignment"><strong>{{'plan.geo_zone_assignment' | translate}}</strong></li>
                        </ul>
                        <div *ngIf="p.id!=_selectedPlan && p.monthlyPrice>=_selectedPlanMonthlyPrice">
                            <button class="btn btn-blue btn-h-blue w-100 mt-2" (click)="savePlan(p.id)">{{'account.choose_plan' | translate}}</button>
                        </div>
                        <div *ngIf="p.monthlyPrice<_selectedPlanMonthlyPrice" class="red-text text-center">
                            <i><span><strong>{{'plan.call_us' | translate}}: </strong>{{constant.tollFreeNumber}}</span></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12" *ngIf="_plans.length>0">
            <div class="card card-body-enabled mt-2">
                <div class="card-body">
                    <div class="mb-2 text-responsive text-center w-100">
                        <h3>{{'plan.enterprise' | translate}}</h3>
                    </div>
                    <div class="text-center"><h2 class="red-text text-responsive">{{'plan.contact_us' | translate}}</h2></div>
                    <hr>
                    <ul>
                        <li><strong>{{'roles.agents_supervisors' | translate}}: </strong>{{_plans[(_plans.length)-1]["agentsSupervisors"]}}+</li>
                        <li><strong>{{'plan.Users' | translate}}: </strong>{{_plans[(_plans.length)-1]["users"]}}+</li>
                    </ul>
                    <div class="red-text text-center"><h5><strong>{{'plan.call_us' | translate}}: </strong><br>{{constant.tollFreeNumber}}</h5></div>
                </div>
            </div>
        </div>
        <button id="cart-updated" routerLink="/main/account-owner/change-plan-prorate" routerLinkActive="active"></button>
    </div>
</div>
